module.exports = __webpack_public_path__ + "img/image32.f96093e3.png";